import {useEffect, useState} from "react";
import Grid from "@mui/material/Grid";
import {
    Box,
    CardHeader,
    IconButton,
    Link,
    Select,
    Snackbar,
    Step,
    StepLabel,
    Stepper,
    TextField,
    Typography
} from "@mui/material";
import { display24HourTime, today} from "../../shared/date.js";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from '@mui/icons-material/Add';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {Crumbs} from "../Crumbs.jsx";
import LoginRequired from "../LoginRequired.jsx";
import {AddEventButton} from "../Button/AddEventButton.jsx";
import EditVenueButton from "../Button/EditVenueButton.jsx";
import { Venue } from "../../shared/type/venue.ts"; 
import { EventArtist } from "../../shared/type/eventArtist.ts"; 
import { EventInstructor } from "../../shared/type/eventInstructor.ts";
import { Event } from "../../shared/type/event.ts";
import { useParams } from "react-router";
import { loadVenues } from "../../shared/type/venue.ts";
import { InstagramEmbed } from "react-social-media-embed";
import {useEvents} from "../DanceEventProvider.jsx"
import DeleteIcon from '@mui/icons-material/Delete';


const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];
const timeSlots = Array.from(Array(26).keys()).slice(9).reduce<{ key: string; label: string }[]>((acc, v) => {
    const hour = (v % 12 === 0 ? 12 : v % 12).toString()
    const hourKey = v.toString().padStart(2,"0")
    const meridian = v > 11 && v < 24 ? "pm" : "am"

    acc.push({
        key: `${hourKey}:00`,
        label: `${hour}:00 ${meridian}`
    })

    acc.push({
        key: `${hourKey}:15`,
        label: `${hour}:15 ${meridian}`
    })

    acc.push({
        key: `${hourKey}:30`,
        label: `${hour}:30 ${meridian}`
    })

    acc.push({
        key: `${hourKey}:45`,
        label: `${hour}:45 ${meridian}`
    })

    return acc;
}, []).map((v, i) => <MenuItem value={v.key} key={i}>{v.label}</MenuItem>

)
const SelectEventVenueStep = (props) => {
 
    const { event, venueList, selectVenueHandler } = props;

    return <Box>
        <Typography variant="overline">Select Venue</Typography>
        <Select fullWidth value={event?.venue?.venueKey ?? ""} displayEmpty onChange={(e) => selectVenueHandler(e.target.value)}>
            <MenuItem key="default" value={""}>Select</MenuItem>
            {venueList.map((v, i) => (
                <MenuItem key={i} value={v.venueKey ?? ""}>{v.name ?? ""}</MenuItem>
            ))}
        </Select>
        <div style={{margin: "20px 0 20px 0"}}>
            <Typography variant="subtitle2" color={"text.secondary"}>Venue not listed?<EditVenueButton venueKey={"new"} /></Typography>

        </div>
    </Box>
}


const SelectEventDateStep = (props) => {
    const { event, setEvent } = props;
    return <Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* (v) => setDate(v.format("YYYY-MM-DD")) */}
            <DateCalendar
                value={dayjs(event.date + "T12:00:00")}
                onChange={(v: dayjs.Dayjs) =>
                    setEvent(prev => {

                    const updated = new Event(prev);
                    updated.date = v.format("YYYY-MM-DD");
                    return updated;
                    })
                }
                sx={{margin: 0}}
                />
            </LocalizationProvider>
        </Box>
}


const SelectEventWhoStep = (props) => {
    const { event, setEvent, setToDelete } = props;
    return <Box>
        <table style={{width: "100%"}}>
            <thead>
                <tr>
                    <th colSpan={2}>
                        <Box mt={2}>
                            <Typography variant={"overline"} color={"text.secondary"}>Musicians</Typography>
                        </Box>
                    </th>
                </tr>
            </thead>
            <tbody>
                {event.event_artists
                    .filter(ea => ea.listing !== "hidden")
                    .map((ea, idx) => (
                    <tr key={`artist-row-${idx}`}>
                        <td>
                            <Select
                                fullWidth
                                value={ea.time || "21:00"}
                                onChange={e => {
                                    const newTime = e.target.value;
                                    setEvent(prev => {
                                        const updated = new Event(prev);
                                        updated.event_artists = updated.event_artists.map((artist, i) =>
                                            i === idx ? { ...artist, time: newTime } : artist
                                        );
                                        return updated;
                                    });
                                }}
                                displayEmpty
                                size="small"
                            >
                                {timeSlots}
                            </Select>
                        </td>
                        <td>
                            <TextField
                                fullWidth
                                label="Artist Name"
                                value={ea.title || ""}
                                onChange={e => {
                                    const newTitle = e.target.value;
                                    setEvent(prev => {
                                        const updated = new Event(prev);
                                        updated.event_artists = updated.event_artists.map((ea, i) =>
                                            i === idx
                                                ? {
                                                    ...ea,
                                                    title: newTitle
                                                }
                                                : ea
                                        );
                                        return updated;
                                    });
                                }}
                                size="small"
                                variant="outlined"
                            />
                        </td>
                        <td>
                            <IconButton
                                size="small"
                                disabled={event.event_artists.length === 1}
                                onClick={() => {
                                    setEvent(prev => {
                                        const updated = new Event(prev);
                                        const removed = updated.event_artists[idx];
                                        updated.event_artists = updated.event_artists.filter(ea => ea !== removed);
                                        setToDelete(prev => [...prev, removed]);
                                        return updated;
                                    });
                                }}
                            >
                                <DeleteIcon fontSize={"80%"} />
                            </IconButton>
                        </td>
                    </tr>
                ))}
                <tr>
                    <td colSpan={3} style={{textAlign: "center"}}>
                        <Button startIcon={<AddIcon/>}
                            onClick={() => {
                                setEvent(prev => {
                                    const updated = new Event(prev);
                                    updated.event_artists = [
                                        ...updated.event_artists,
                                        new EventArtist({time: "21:00"})
                                    ];
                                    return updated;
                                });
                            }}>
                            Add another musician
                        </Button>
                    </td>
                </tr>
                <tr>
                    <th colSpan={3}>
                        <Box mt={3}>
                            <Typography variant={"overline"} color={"text.secondary"}>Lessons</Typography>
                        </Box>
                    </th>
                </tr>
                {event.event_instructors
                    .filter(ei => ei.listing !== "hidden")
                    .map((ei, idx) => (
                    <tr key={`instructor-row-${idx}`}>
                        <td>
                            <Select
                                fullWidth
                                value={ei.time || "21:00"}
                                onChange={e => {
                                    const newTime = e.target.value;
                                    setEvent(prev => {
                                        const updated = new Event(prev);
                                        updated.event_instructors = updated.event_instructors.map((instructor, i) =>
                                            i === idx ? { ...instructor, time: newTime } : instructor
                                        );
                                        return updated;
                                    });
                                }}
                                displayEmpty
                                size="small"
                            >
                                {timeSlots}
                            </Select>
                        </td>
                        <td>
                            <TextField
                                label="Title"
                                placeholder="EX: Beginner 2-Step Lesson by Austin 2-Step"
                                fullWidth
                                value={ei.title || ""}
                                onChange={e => {
                                    const newTitle = e.target.value;
                                    setEvent(prev => {
                                        const updated = new Event(prev);
                                        updated.event_instructors = updated.event_instructors.map((ei, i) =>
                                            i === idx
                                                ? {
                                                    ...ei,
                                                    title: newTitle
                                                }
                                                : ei
                                        );
                                        return updated;
                                    });
                                }}
                                size="small"
                                variant="outlined"
                            />
                        </td>
                        <td>
                            <IconButton
                                size="small"
                                disabled={event.event_instructors.length === 1}
                                onClick={() => {
                                    setEvent(prev => {
                                        const updated = new Event(prev);
                                        const removed = updated.event_instructors[idx];
                                        updated.event_instructors = updated.event_instructors.filter(ei => ei !== removed);
                                        setToDelete(prev => [...prev, removed]);
                                        return updated;
                                    });
                                }}
                            >
                                <DeleteIcon fontSize="80%" />
                            </IconButton>
                        </td>
                    </tr>
                ))}
                <tr>
                    <td colSpan={3} style={{textAlign: "center"}}>
                        <Button startIcon={<AddIcon/>}
                            onClick={() => {
                                setEvent(prev => {
                                    const updated = new Event(prev);
                                    updated.event_instructors = [
                                        ...updated.event_instructors,
                                        new EventInstructor({
                                            time: "21:00"
                                        })
                                    ];
                                    return updated;
                                });
                            }}>
                            Add another Lesson
                        </Button>
                    </td>
                </tr>
            </tbody>
        </table>
    </Box>               
}

const SelectEventOtherStep = (props) => {
    const { event, setEvent } = props;
    return <Box>
        <Typography variant="subtitle1">Optional Info</Typography>
        <TextField
            label="Event Title"
            value={event.title || ""}
            helperText={"Examples: Record Release Show, SXSW Party, Weekly Dance"}
            onChange={e => {
                const newValue = e.target.value;
                setEvent(prev => {
                    const updated = new Event(prev);
                    updated.title = newValue === "" ? null : newValue;
                    return updated;
                });
            }}
            fullWidth
            margin="normal"
        />
        <TextField
            label="Instagram Post"
            value={event.instagramUrl || ""}
            helperText="Optional link to Instagram post. Stories and Reels not supported."
            onChange={e => {
                const newValue = e.target.value;
                setEvent(prev => {
                    const updated = new Event(prev);
                    updated.instagramUrl = newValue === "" ? null : newValue;
                    return updated;
                });
            }}
            fullWidth
            margin="normal"
        />
        <TextField
            label="Ticket Link"
            value={event.ticketUrl || ""}
            helperText="Optional link to buy tickets"
            onChange={e => {
                const newValue = e.target.value;
                setEvent(prev => {
                    const updated = new Event(prev);
                    updated.ticketUrl = newValue === "" ? null : newValue;
                    return updated;
                });
            }}
            fullWidth
            margin="normal"
        />
    </Box>
}

const PreviewBox = (props) => {
    const { event, toDelete, title, bar } = props;

    return <Card style={{height: "100%"}}>
        <CardHeader title={title} />
        <CardContent>
            {bar !== undefined && bar}
            {/* {event.documentId && <Typography variant="h6">{event.documentId}</Typography>} */}
            {event.title && <Typography variant="h6">{event.title}</Typography>}
            <Typography variant="overline" color={"text.secondary"}>Venue</Typography>
            <Typography variant="subtitle2">{event?.venue?.name || "Pending"}</Typography>
            <Typography variant="overline" color={"text.secondary"}>Date</Typography>
            <Typography variant="subtitle2">{event?.date || "Pending"}</Typography>

            {/* Event Artists Section */}
            <Box>
                <Typography variant="overline" color={"text.secondary"} sx={{ mt: 2 }}>Musicians</Typography>
                {event.event_artists && event.event_artists.filter(ea => ea.title).length > 0 ? (
                    event.event_artists.filter(ea => ea.title && ea.listing !== "hidden").map((ea, idx) => (
                        <Typography key={`preview-artist-${idx}`} variant="body2">
                            {ea.time ? display24HourTime(ea.time) + " - " : ""}
                            {ea.title || ""}
                        </Typography>
                    ))
                ) : (
                    <Typography variant="body2"><i> No musicians added </i></Typography>
                )}
            </Box>

            {/* Event Instructors Section */}
            <Box>
                <Typography variant="overline" color={"text.secondary"} sx={{ mt: 2 }}>Lessons</Typography>
                {event.event_instructors && event.event_instructors.filter(ei => ei.title).length > 0 ? (
                    event.event_instructors.filter(ei => ei.title && ei.listing !== "hidden").map((ei, idx) => (
                        <Typography key={`preview-instructor-${idx}`} variant="body2">
                            {ei.time ? display24HourTime(ei.time) + " - " : ""}
                            {ei.title || ""}
                        </Typography>
                    ))
                ) : (
                    <Typography variant="body2"><i> No lessons added </i></Typography>
                )}
            </Box>
            {event.ticketUrl && <Box>
                <Typography variant="overline" color={"text.secondary"} sx={{ mt: 2 }}>Ticket Link</Typography>
                <div>
                    <Link href={event.ticketUrl} target="_blank" rel="noopener">
                        Tickets
                    </Link>
                </div>
            </Box>}
            {event.instagramUrl && <Box>
                <Typography variant="overline" color={"text.secondary"} sx={{ mt: 2 }}>Instagram</Typography>
                <InstagramEmbed url={event.instagramUrl} width={320} />
            </Box>}

            {/* Show event_artists and event_instructors to be deleted */}
            {toDelete.length > 0 && (
                <Box mt={4}>
                    <Typography variant="overline" color="error">To Be Deleted</Typography>

                   {toDelete.map((item, idx) => (
                       <Typography key={`to-delete-${idx}`} variant="body2" color="error">
                           {display24HourTime(item.time)} - {item.title || item.artist?.name || "Unknown Artist"}
                       </Typography>
                   ))}
                </Box>
            )}
        </CardContent>
    </Card>
}

export const EventEditPage = (props) => {

    const params = new URLSearchParams(window.location.search)
    const {myCreatedEventMap} = useEvents();
    const initialEvent = (id) => {
        if (myCreatedEventMap.hasOwnProperty(id)) {
            return myCreatedEventMap[id]
        }
        return new Event({
            date: params.has("date") ? params.get("date") : today(),
            event_artists: [new EventArtist({time: "21:00"})],
            event_instructors: [new EventInstructor({time: "21:00"})]
        })
    }

    const routeParams = useParams(); 

    // Get eventId from route /event/edit/:id if present
    const [id, setId] = useState(routeParams.id ?? "");

    const [activeStep, setActiveStep] = useState(0);


    const [venueList, setVenueList] = useState<Venue[]>([]);

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [snackBarMessage, setSnackBarMessage] = useState("")
    const [event, setEvent] = useState(initialEvent(id))
    const [toDelete, setToDelete] = useState([])



    const handleSubmit = async (e) => {
        setLoading(true);
        try {
            // Save main event

            const token = window.localStorage.getItem("authToken");
            const newEvent = await fetch(`${BACKEND_HOST}/events/save`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({data: event, toDelete: toDelete})
            })
            .then(res => {
                if (res.ok) {
                    setSuccess(true);
                    setSnackBarMessage("Event Saved");
                    res.json()
                        .then(data => setEvent(Event.fromStrapi(data)));
                }
            })

        } catch (err) {
            setSuccess(false);
            setSnackBarMessage("Save Failed");
        }
        setLoading(false);
        setSnackBarOpen(true);
    }

    useEffect(() => {
        // Load all venues to populate for search box using Strapi and VenueList
        loadVenues("local")
            .then(venues => setVenueList(venues))

        // Fetch event from Strapi if editing an existing event
        const fetchEvent = async () => {
            if (!id || id === 'new') return;
            const res = await fetch(
                `${BACKEND_HOST}/events/${id}?populate[]=venue&populate[]=event_artists.artist&populate[]=event_instructors.instructor`
            );
            const data = await res.json()
            // Use Event.fromStrapi to construct the event object with populated venue, event_artists, and event_instructors
            setEvent(Event.fromStrapi(data));
        };

        fetchEvent();
    }, [])

    const selectVenueHandler = (venueKey) => {
        const venueObj = venueList.find((v: Venue) => v.venueKey === venueKey) || null;

        // Update the event object with the new Venue
        setEvent(prev => {
            const updated = new Event(prev);
            updated.venue = venueObj;
            return updated;
        });
    }

    var stepContent;
    var stepComplete;
    var formComplete = false;
    
    switch (activeStep) {
        case 0:
            stepContent = <SelectEventVenueStep event={event} venueList={venueList} selectVenueHandler={selectVenueHandler} />
            stepComplete = event.venue !== null;
            break;
        case 1:
            stepContent = <SelectEventDateStep event={event} setEvent={setEvent} />
            stepComplete = event.date !== null;
            break;
        case 2:
            stepContent = <SelectEventWhoStep event={event} setEvent={setEvent} toDelete={toDelete} setToDelete={setToDelete} />;
            const hasArtists = event.event_artists.reduce((acc, ea) => acc + (ea.title ? 1 : 0), 0);
            const hasInstructors = event.event_instructors.reduce((acc, ei) => acc + (ei.title ? 1 : 0), 0);

            stepComplete = hasArtists > 0 || hasInstructors > 0;
            break;
        case 3:
            stepContent = <SelectEventOtherStep event={event} setEvent={setEvent} />
            stepComplete = false;
            formComplete = true;
            break;
    }


    const StepControl = params => {
        const { stepComplete, activeStep, setActiveStep, formComplete, handleSubmit } = params;

        return <Box display={"flex"} justifyContent={"space-between"} mt={2}>
            <Button disabled={activeStep === 0} onClick={()=> setActiveStep(activeStep - 1)}>Back</Button>
            {!formComplete && <Button disabled={!stepComplete} variant={"outlined"} onClick={()=> setActiveStep(activeStep + 1)}>Next</Button>}
            {formComplete && <Button variant={"contained"} color={"warning"} onClick={(e) => handleSubmit(e)}>Save</Button>}
        </Box>
    }


    var contents
    if (success) {
        const bar = <Box>
                <Button size={"small"} href={"/event/edit/" + event.documentId}>Edit Again</Button> &nbsp;&nbsp;&nbsp;
                <AddEventButton /> &nbsp;&nbsp;&nbsp;
                <Button size={"small"} href={"/account/events"}>All Events I Created</Button>
            </Box>
        contents = <Box>
                <PreviewBox event={event} toDelete={[]} title={"Event Saved"} bar={bar} />
            </Box>
    } else {
        contents = <Grid container spacing={2}>
            <Grid item xs={12}>
            <Snackbar anchorOrigin={{vertical: "top", horizontal: "center"}} open={snackBarOpen}
                          message={snackBarMessage} autoHideDuration={2000}
                          onClose={() => setSnackBarOpen(false)}/>
                {/* <Box fullWidth mb={2} display={"flex"} justifyContent={"center"}>
                    <Typography variant="h6">Add Event</Typography>
                </Box> */}
            </Grid>
            <Grid item xs={12} md={6}>
                <Box>
                    <Stepper activeStep={activeStep} orientation={"horizontal"}>
                        <Step>
                            <StepLabel>Where</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>When</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Who</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>Other</StepLabel>
                        </Step>

                    </Stepper>
                </Box>
                <Box mt={2} style={{height: "40vh", overflowY: "auto"}}>
                    {stepContent}
                </Box>
                <Box mx={2}>
                    <StepControl stepComplete={stepComplete} activeStep={activeStep} setActiveStep={setActiveStep} formComplete={formComplete} handleSubmit={handleSubmit} />
                </Box>

                {activeStep === 3 && <Box mt={6} mb={4} mx={2}>
                    
                </Box>}
            </Grid>
            <Grid item xs={12} md={6}>
                <PreviewBox event={event} toDelete={toDelete} title={"Preview"}/>
            </Grid>
        </Grid>

    }

    return <Box>
        <Box>
            <Crumbs crumbs={[
                {title: "Where to Dance", href: "/where-to-dance"},
                {title: "Event Editor"}
            ]} />
        </Box>
        <LoginRequired>
            {contents}
        </LoginRequired>
    </Box>
}
